module.exports = __webpack_public_path__ + "static/001.thumb-786382f3aba29018fabdb9205a2b4f1b.jpg";